<template>
  <div class="select-wrapper">
    <div class="flex justify-between">
      <span class="text-lg font-bold">已选择项({{ uniqueList.length }})</span>
      <span class="cursor-pointer text-primary" @click="handleEmpty">清空</span>
    </div>
    <div class="select-height border border-gray-400 border-solid mt-3">
      <div class="observer-content">
        <i class="start"></i>
        <template v-for="(item, index) in uniqueList">
          <!-- 根据isRender判断是否渲染 -->
          <div
            v-if="isRender(index)"
            :key="`${item.id || index}`"
            class="flex justify-between items-center pl-2 pr-2 h-8 leading-8"
            :class="{ 'bg-gray-200': index % 2 === 0 }"
          >
            <span class="w-48 overflow-hidden whitespace-no-wrap select-name" :title="item.name">{{ item.name }}</span>
            <i class="el-icon-error text-gray-500 hover:text-primary cursor-pointer" @click="deleteItem(item)"></i>
          </div>
        </template>
        <i class="end"></i>
      </div>
    </div>
  </div>
</template>

<script>
// 最大渲染梳理
const maxRender = 60;
// item高度
const itemHeight = 32;
const refreshRender = 30;

export default {
  name: "RcObjectSelected",
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      observer: null,
      startIndex: 0,
      observerContent: null
    };
  },
  computed: {
    uniqueList() {
      const map = {};
      const uniqueList = [];
      this.data.forEach(item => {
        if (!map[item.id]) {
          map[item.id] = true;
          uniqueList.push(item);
        }
      });

      return uniqueList;
    },
    endIndex() {
      return this.startIndex + maxRender;
    },
    isRender() {
      return i => i >= this.startIndex && i < this.endIndex;
    }
  },
  created() {
    // 加载时初始化监听
    this.initObserve();
  },
  beforeDestroy() {
    // 销毁时断开链接
    this.observer && this.observer.disconnect && this.observer.disconnect();
  },
  methods: {
    handleEmpty() {
      this.$emit("clearAllSelect");
    },
    deleteItem(item) {
      this.$emit("deleteSelect", item);
    },
    initObserve() {
      this.$nextTick(() => {
        // 父级容器
        this.observerContentDom = document.querySelector(".observer-content");
        // 开始结束容器
        const startDom = document.querySelector(".start");
        const endDom = document.querySelector(".end");

        const domPaddingTop = parseFloat(window.getComputedStyle(this.observerContentDom).paddingTop) || 0;

        this.observer = new IntersectionObserver(entries => {
          // 避免start和end同事出现在视区
          if (entries.length >= 2) { return; }

          const [observerDom] = entries;
          if (!observerDom.isIntersecting) { return; }

          if (observerDom.target === endDom) {
            // 向下移动
            const resultIndex = this.startIndex + refreshRender;
            this.startIndex = resultIndex > this.uniqueList.length ? this.startIndex : resultIndex;
          } else {
            // 向上移动
            const resultIndex = this.startIndex - refreshRender;
            this.startIndex = resultIndex < 0 ? 0 : resultIndex;
          }

          this.observerContentDom.style.paddingTop = `${this.startIndex * itemHeight + domPaddingTop}px`;
        });

        // 监听开始/结束dom
        this.observer.observe(startDom);
        this.observer.observe(endDom);
      });
    }
  }
};
</script>

<style lang="scss">
  .select-wrapper {
    .select-name {
      text-overflow: ellipsis;
    }
    .select-height {
      height: 582px;
      box-sizing: content-box;
      overflow-y: auto;
    }
  }
</style>
